<template>
  <div v-if="animation" class="absolute inset-0 z-0">
    <SnowFlakesComponent v-if="animation === 'snowflakes'" />
    <ChristmasLightsComponent v-if="animation === 'christmasLights'" />
  </div>
</template>

<script>
import SnowFlakesComponent from '@/views/layouts/main-layout/SeasonalEffects/SnowFlakesComponent.vue'
import { mapGetters } from 'vuex'
import ChristmasLightsComponent from '@/views/layouts/main-layout/SeasonalEffects/ChristmasLightsComponent.vue'
import moment from 'moment'

export default {
  name: 'SeasonalEffect',
  components: { ChristmasLightsComponent, SnowFlakesComponent },
  computed: {
    ...mapGetters({
      animationEffect: 'auth/getAnimation'
    }),
    animation() {
      if (this.animationEffect === 'none') {
        return null
      }
      if (this.animationEffect === 'auto') {
        if (moment().month() === 11) {
          return 'snowflakes'
        }
        return null
      }
      return this.animationEffect
    }
  }
}
</script>

<style scoped></style>
